export const sortRowsByConfig = (rows = [], config = {}) => {
  const sortRules = config?.rowSort;

  if (!Array.isArray(sortRules) || !sortRules.length) {
    return rows;
  }

  return [...rows].sort((a, b) => {
    for (const rule of sortRules) {
      const { field, order = [] } = rule;

      const aIndex = order.indexOf(a?.[field]);
      const bIndex = order.indexOf(b?.[field]);

      if (aIndex !== bIndex) {
        return aIndex - bIndex;
      }
    }

    return 0;
  });
};
export const generateRowsFromConfig = (config = {}) => {
  const template = config?.rowTemplate;

  if (!template) return [];

  const { field, values = [] } = template;

  return values.map((value) => ({
    [field]: value,
  }));
};
